<template>
  <v-container class="v-sheet-main-container creation elevation-12">
    <v-toolbar flat class="v-toolbar-custom">
      <v-toolbar-title class="ma-2">
        {{ $t('newMedia.title') }}
      </v-toolbar-title>
      <v-chip class="ma-2" large outlined style="max-height:40px;border:2px solid;" color="white" text-color="white" v-if="selectedMediaType" @click="resetAllChoices" >
        <v-img style="margin-left:-4px; max-height:38px; max-width:38px" class="mr-2" contain :src="selectedMediaType.imgSrcDark"></v-img>
        {{ selectedMediaType.mediaName }}
        <v-icon style="margin-left:6px;">mdi-undo-variant</v-icon>
      </v-chip>
      <v-chip class="ma-2" large outlined style="max-height:40px;border:2px solid;" color="white" text-color="white" v-if="selectedImport" @click="selectedImport=null">
        <v-img style="margin-left:-4px; max-height:38px; max-width:38px" class="mr-2" contain :src="selectedImport.imgSrcDark"></v-img>
        {{ selectedImport.importName }}
        <v-icon style="margin-left:6px;">mdi-undo-variant</v-icon>
      </v-chip>
    </v-toolbar>
    <v-sheet id="my-content-wrapper" class="border-main-content elevation-3" :class="centered">
      <template v-if="!selectedMediaType">
        <v-col class="col-md-12">
          <v-flex>
            <h1>{{ $t('newMedia.subtitle') }}</h1>
            <v-row justify="center">
              <v-col v-for="mediaType in mediaTypes" :key="mediaType.id" cols="12" :md="tailleVCard">
                <v-card :ripple="false" flat @click="showSecondMenu(mediaType)" class="inherit-background new-media-image-bg image-overflow-visible">
                  <v-img class="mx-auto" :src="mediaType.imgSrcDark" max-width="182">
                  </v-img>
                  <v-card-text>
                    <div> {{ mediaType.mediaName }} </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-flex>
        </v-col>
      </template>
      <template v-if="selectedMediaType && !selectedImport">
        <v-col class="col-md-12">
          <v-flex>
            <h1>{{ $t('newMedia.subtitle2') }}</h1>
            <v-row justify="center">
                <v-col v-for="importType in importTypes" :key="importType.id" cols="12" :md="tailleVCard">
                <v-card :ripple="false" flat @click="showThirdMenu(importType)" class="inherit-background new-media-image-bg image-overflow-visible">
                  <v-img class="mx-auto" :src="importType.imgSrcDark" max-width="182">
                  </v-img>
                  <v-card-text>
                    <div> {{ importType.importName }} </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-flex>
        </v-col>
      </template>
      <template v-if="selectedMediaType && !isVideo && selectedImport!=null && selectedImport.name=='upload'">
        <div class="d-flex justify-center" style="width:100%;">
          <v-card class="pa-4" style="background-color:var(--v-contrast-base)">
            <v-row>
              <v-tooltip open-delay="800ms" bottom color="rgba(var(--new-media-rgb),1)">
                <template v-slot:activator="{ on }">
                  <img class="ml-4" style="height:274px;width:274px;" src="@/assets/images/illu_upload_newmedia_0.png" v-on="on">
                </template>
                <span>Illustration : Ivan Haidutski</span>
              </v-tooltip>
              <v-col>
                <v-card-text class="mt-6 title font-italic font-weight-regular" style="color:var(--v-primary-base);!important">
                    Plus qu'un pas vers la création !
                </v-card-text>
                <input ref="fileUpload" type="file" @change="getUploadedFile" :accept="fileAccept" hidden>
                <v-card-text>
                  {{ $t('newMedia.uploadImageText1') }}
                  <h3 class="my-4" style="text-decoration: underline; font-weight: bold;">{{ $t('newMedia.uploadImageText2') }}</h3>
                  {{ $t('newMedia.uploadImageText3') }}
                  <br>
                  {{ $t('newMedia.uploadImageText4') }}
                </v-card-text>
              </v-col>
            </v-row>
            <v-card-actions class="justify-center">
              <v-btn large outlined rounded style="padding:20px!important" class="custom-valid-btn new-media" @click="uploadFile">  {{ $t('newMedia.btnUploadImage') }} </v-btn>
            </v-card-actions>
            <!-- <v-btn>{{ $t('newMedia.btnUpload2') }}</v-btn> -->
          </v-card>
        </div>
      </template>
      <template v-if="selectedMediaType && !isVideo && selectedImport!=null && selectedImport.name=='gallery'">
        <pixabay-image-component v-bind:modal="selectedMediaType.route" />
      </template>
      <template v-if="selectedMediaType && isVideo && selectedImport!=null && selectedImport.name=='upload'">
        <div class="d-flex justify-center" style="width:100%;">
          <v-card class="pa-4" style="background-color:var(--v-contrast-base)">
            <v-row>
              <v-tooltip open-delay="800ms" bottom color="rgba(var(--new-media-rgb),1)">
              <template v-slot:activator="{ on }">
                <img style="height:274px;width:274px;" src="@/assets/images/illu_upload_newmedia_4.png" v-on="on">
              </template>
              <span>Illustration : Ivan Haidutski</span>
            </v-tooltip>
            <v-col>
              <v-card-text class="title font-italic font-weight-regular" style="color:var(--v-primary-base);!important">
                Plus qu'un pas vers la création !
              </v-card-text>
              <input name="videofile" ref="fileUpload" type="file" @change="getUploadedFile($event)" :accept="fileAccept" hidden />
              <v-card-text>
                {{ $t('newMedia.uploadVideoText1') }}
                <h3 class="my-4" style="text-decoration: underline; font-weight: bold;">{{ $t('newMedia.uploadVideoText2') }}</h3>
                {{ $t('newMedia.uploadVideoText3') }}
                <br>
                {{ $t('newMedia.uploadVideoText4') }}
              </v-card-text>
            </v-col>
            </v-row>
            <v-card-actions class="justify-center">
              <v-btn large outlined rounded style="padding:20px!important" class="custom-valid-btn new-media" @click="uploadFile">  {{ $t('newMedia.btnUploadVideo') }} </v-btn>
            </v-card-actions>
            <!-- <v-btn>{{ $t('newMedia.btnUpload2') }}</v-btn> -->
          </v-card>
        </div>
      </template>
      <template v-if="selectedMediaType && isVideo && selectedImport!=null && selectedImport.name=='gallery'">
        <pixabay-video-component />
      </template>
    </v-sheet>
    <v-dialog v-model="dialogWip" persistent overlay-color="dialog" overlay-opacity="0.8" max-width="350px" transition="scale-transition">
      <WipDialog />
    </v-dialog>
    <modals-container class="modal-container"/>
  </v-container>
</template>

<script>
import CreationModal from './Subcomponents/CreationModal'
import VideoUploadModal from './Subcomponents/VideoUploadModal'
import PixabayImageComponent from './Subcomponents/PixabayImageComponent'
import PixabayVideoComponent from './Subcomponents/PixabayVideoComponent'
import AnimationModal from './Subcomponents/AnimationModal'
import FtpService from '@/services/FTPService'
import WipDialog from './Subcomponents/WipDialog'
//  import axios from 'axios'

export default {
  data () {
    return {
      mediaTypes: [
        { imgSrcDark: require('@/assets/images/dark_ic_new_page.png'), mediaName: this.$i18n.t('newMedia.media1'), route: 'image' },
        { imgSrcDark: require('@/assets/images/dark_ic_new_anim.png'), mediaName: this.$i18n.t('newMedia.media2'), route: 'animation' },
        { imgSrcDark: require('@/assets/images/dark_ic_new_video.png'), mediaName: this.$i18n.t('newMedia.media3'), route: 'video' }
      ],
      importTypes: [
        { imgSrcDark: require('@/assets/images/dark_ic_new_upload.png'), importName: this.$i18n.t('newMedia.importType1'), name: 'upload' },
        { imgSrcDark: require('@/assets/images/dark_ic_new_stock.png'), importName: this.$i18n.t('newMedia.importType2'), name: 'gallery' }
      ],
      images: {
        upload: require('@/assets/images/dark_ic_new_upload.png'),
        gallery: require('@/assets/images/dark_ic_new_stock.png')
      },
      validFormats: [
        'image/jpeg', 'image/gif', 'image/bmp', 'image/png', 'application/pdf'
      ],
      tailleVCard: 1,
      selectedMediaType: null,
      selectedImport: null,
      uploadedFile: [],
      modalOpen: false,
      fileAccept: '.pdf,.png,.jpg,.jpeg,.gif,.bmp',
      isVideo: false,
      centered: 'custom-center',
      dialogWip: false,
      retail: [
        'CAS_', 'ITM_', 'LEC_', 'SU_', 'NETTO_', 'SPAR_', 'CAR_', 'BLG_', 'BC_', 'BRICO_', 'TESTS'
      ]
    }
  },
  components: {
    CreationModal,
    PixabayImageComponent,
    PixabayVideoComponent,
    AnimationModal,
    WipDialog
  },
  async mounted () {
    if (this.$store.state.user.id === 295) {
      this.importTypes.pop()
    }
    var brand
    if (this.$store.state.selectedSite.SitNom.includes('_')) {
      brand = this.$store.state.selectedSite.SitNom.substring(0, this.$store.state.selectedSite.SitNom.indexOf('_')) + '_'
    } else {
      brand = this.$store.state.selectedSite.SitNom
    }
    if (!this.retail.includes(brand)) {
       this.mediaTypes = [
        { imgSrcDark: require('@/assets/images/dark_ic_new_page.png'), mediaName: this.$i18n.t('newMedia.media1'), route: 'image' },
        { imgSrcDark: require('@/assets/images/dark_ic_new_video.png'), mediaName: this.$i18n.t('newMedia.media3'), route: 'video' }
      ]
    }
    this.tailleVCard = Math.floor(12 / (this.mediaTypes.length * 2))
  },
  methods: {
    showSecondMenu: function (mediaType) {
      this.selectedMediaType = mediaType
      if (this.selectedMediaType.route === 'video') {
        this.isVideo = true
        this.fileAccept = '.avi,.mp4,.flv'
      } else if (this.selectedMediaType.route === 'image'){
        this.isVideo = false
        this.fileAccept = '.pdf,.png,.jpg,.jpeg,.gif,.bmp'
      } else if (this.selectedMediaType.route === 'animation') {  
        this.isVideo = false
        this.fileAccept = '.pdf,.png,.jpg,.jpeg,.gif,.bmp'  
      }
      /* if (this.$store.state.user) {
        this.showThirdMenu({ imgSrc: require('@/assets/images/dark_ic_new_upload.png'), importName: this.$i18n.t('newMedia.importType1'), name: 'upload' })
      } */
    },
    showThirdMenu: function (importType) {
      this.selectedImport = importType
      this.centered = this.selectedImport.name === 'gallery' ? '' : 'custom-center'
    },
    uploadFile: function () {
      this.$refs.fileUpload.click()
    },
    async getUploadedFile (event) {
      this.uploadedFile = this.$refs.fileUpload.files[0]
      this.$store.dispatch('setFile', this.uploadedFile)
      if (!this.validFormats.includes(this.uploadedFile.type) && !this.uploadedFile.type.includes('video/')) {
      } else {  
        if (this.uploadedFile.type === 'application/pdf') {
          let data = new FormData()
          let file = event.target.files[0]
          data.append('file', file)
          let config = {
            header : {
              'Content-Type' : 'multipart/form-data'
            }
          }
          const response = await FtpService.convertPDF(data, config)
          if (response.data.filePath) {
            this.$store.dispatch('setFile', response.data.filePath)
            this.$refs.fileUpload.value = ''
            this.$modal.show(CreationModal, {isPDF: true}, {clickToClose: false, adaptive: true, transition: 'scale-transition', width: '80%', height: '90%'})
          }
        } else if (this.uploadedFile.type.includes('video/')) {
          this.$refs.fileUpload.value = ''
          this.$modal.show(VideoUploadModal, {}, {clickToClose: false, adaptive: true, transition: 'scale-transition', width: '80%', height: '90%'})
        } else if (this.uploadedFile.type.includes('image') && this.selectedMediaType.route === 'image') {
          this.$refs.fileUpload.value = ''
          this.$modal.show(CreationModal, {isPDF: false}, {clickToClose: false, adaptive: true, transition: 'scale-transition', width: '80%', height: '90%'})
        } else if (this.uploadedFile.type.includes('image') && this.selectedMediaType.route === 'animation') {
          this.$refs.fileUpload.value = '' 
          this.$modal.show(AnimationModal, {}, {clickToClose: false, adaptive: true, transition: 'scale-transition', width: '80%', height: '90%'})
        }
      }
    },
    resetAllChoices: function () {
      this.selectedMediaType = null
      this.selectedImport = null
    },
    openModal: function () {
      this.modalOpen = !this.modalOpen
    },
    closeWIPDialog () {
      this.dialogWip = false
    }
  },
  watch: {
    selectedImport: function () {
      if (this.selectedImport) {
        this.centered = this.selectedImport.name === 'gallery' ? '' : 'custom-center'
      } else {
        this.centered = 'custom-center'
      }
    }
  }
}
</script>

<style scoped>

/* .modal{
  overflow: auto;
} */

h1{
  text-align: center;
}

</style>
